import { isUndefinedOrNull } from 'util/checks'

/**
 * Receives a string that is expected to have a path structure e.g. 'foo/bar/baz'
 *
 * Then, split the string into segments, using the slashes as reference.
 *
 * From that, returns last segment.
 *
 * @param fullPath string that represents a path.
 * @returns last segment of that string.
 */
export const getLastPathSegment = (fullPath: string) => {
  if (isUndefinedOrNull(fullPath)) {
    throw new Error('Argument given is undefined or null.')
  }

  const segments = fullPath.split('/')
  return segments[segments.length - 1]
}
